<template>
<div class="MStepTwo">
    <div class="content_warp">
        <div class="type_box">
            <div class="row_box">
                <p class="title_text">员工通过何种方式持股<img @click="tipsClick('员工通过何种方式持股', tipsTextOne)" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-cell :title="textOne === '' ? '请选择' : textOne" is-link @click="showPickerOne = true"/>
            </div>
            <div v-show="formParams.holdingtype === 1" class="row_box">
                <p class="title_text">是否办理工商变更</p>
                <van-cell :title="textTwo === '' ? '请选择' : textTwo" is-link @click="showPickerTwo = true"/>
            </div>
            <div class="row_box">
                <p class="title_text">股权激励的股份来源<img @click="tipsClick('股权激励的股份来源', tipsTextTwo)" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-cell :title="textThree === '' ? '请选择' : textThree" is-link @click="showPickerThree = true"/>
            </div>
        </div>
    </div>
    <van-popup v-model="showPickerOne" position="bottom">
        <van-picker
            show-toolbar
            :columns="optionDataOne"
            @cancel="showPickerOne = false"
            @confirm="onConfirmOne"
        />
    </van-popup>

    <van-popup v-model="showPickerTwo" position="bottom">
        <van-picker
            show-toolbar
            :columns="optionDataTwo"
            @cancel="showPickerTwo = false"
            @confirm="onConfirmTwo"
        />
    </van-popup>

    <van-popup v-model="showPickerThree" position="bottom">
        <van-picker
            show-toolbar
            :columns="optionDataThree"
            @cancel="showPickerThree = false"
            @confirm="onConfirmThree"
        />
    </van-popup>
    <div class="btn_box">
        <div @click="upStep" class="up_btn">上一步</div>
        <div @click="nextStep" class="next_btn">下一步</div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
export default {
    name: 'MStepTwo',
    props: ['formParams'],
    data() {
        return {
            tipsTextOne: '<span>自然人持股：</span>即激励对象直接持有主体公司的股份,员工可在股东会行使表决权，并拥有法律法规赋予的其他股东权利。<br/><br/><span>通过有限公司持股：</span>通过平台间接持有公司股权，并通过参与有限公司持股平台股东决策拥有公司表决权。<br/><br/><span>通过有限合伙企业持股：</span>通过平台间接持有公司股权，员工不具备表决权。',
            tipsTextTwo: '<span>增资扩股：</span>公司总股本增加，原股东股份比例被稀释，激励对象购股资金进入公司账户。 <br/><br/><span> 单一股东转让：</span>该股东股份减少，激励对象的购股资金归转让方。 <br/><br/><span>全体原股东等比例转让：</span>原股东股份比例减少，激励对象购股资金归全体原股东。',
            // formParams: {
            //     holdingtype: 1, // 持股方式 1 通过自然人持股 2 通过有限公司持股 3 通过有限合伙企业持股,
            //     ischangereg: '', // 是否工商变更 0否 1是
            //     sharesource: '' // 激励股份来源： 1 增资扩股 2 单一原股东转让 3 全体原股东等比例转让
            // },

            textOne: '通过自然人持股', // 员工通过何种方式持股文本
            showPickerOne: false,
            optionDataOne: [
                {text: '通过自然人持股', id: 1},
                {text: '通过有限公司持股', id: 2},
                {text: '通过有限合伙企业持股', id: 3}
            ],

            textTwo: '', // 是否办理工商变更
            showPickerTwo: false,
            optionDataTwo: [
                {text: '是', id: 1},
                {text: '否', id: 0}
            ],

            textThree: '', // 股权激励的股份来源
            showPickerThree: false,
            optionDataThree: [
                {text: '增资扩股', id: 1},
                {text: '单一原股东转让', id: 2},
                {text: '全体原股东等比例转让', id: 3}
            ],
        }
    },
    mounted() {},
    methods: {
        // 显示对应提示弹窗 及标题和内容
        tipsClick(tit, des) {
            this.$emit('setTipsPopInfo', tit, des)
        },
        onConfirmOne(value) {
            // console.log(value)
            this.formParams.holdingtype = value.id
            this.textOne = value.text
            this.showPickerOne = false
            if (value.id !== 1) {
                this.formParams.ischangereg = ''
                // this.textTwo = ''
            } else {
                if (this.textTwo === '是') {
                    this.formParams.ischangereg = 1
                }
                if (this.textTwo === '否') {
                    this.formParams.ischangereg = 0
                }
            }
        },
        onConfirmTwo(value) {
            // console.log(value)
            this.formParams.ischangereg = value.id
            this.textTwo = value.text
            this.showPickerTwo = false
        },
        onConfirmThree(value) {
            // console.log(value)
            this.formParams.sharesource = value.id
            this.textThree = value.text
            this.showPickerThree = false
        },
        // 上一步
        upStep() {
            this.$emit('setStepValue', 0)
        },
        // 下一步
        nextStep() {
            if (this.formParams.holdingtype === '') {
                Toast('请选择员工通过何种方式持股')
                return
            }
            if (this.formParams.holdingtype === 1) {
                if (this.formParams.ischangereg === '') {
                    Toast('请选择是否办理工商变更')
                    return
                }
            }
            // else {
            //     this.formParams.ischangereg = ''
            // }
            if (this.formParams.sharesource === '') {
                Toast('请选择股权激励的股份来源')
                return
            }
            // console.log(this.formParams)
            this.$emit('setStepValue', 2)
        },
        
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepTwo {
    padding-bottom: 0.8rem;
    padding: 0.32rem;
    background-color: #fff;
    // height: 8rem;
    // min-height: calc(100vh - 5rem);
    .card {
        .card_item {
            font-size: 0.32rem;
            height: 0.7rem;
            line-height: 0.7rem;
            text-align: center;
            // box-sizing: border-box;
            border: 0.01rem solid #409EFF;
            color: #409EFF;
        }
        .card_item + .card_item {
            margin-top: 0.32rem;
        }
        .card_item.active {
            background-color: #409EFF;
            color: #FFF;
        }

    }
    .btn_box {
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        width: 100vw;
        &>div {
            width: 50vw;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 0.32rem;
            background-color: #E5E5E5;
            color: #666;
        }
        .next_btn {
            background-color: #409EFF;
            color: #fff;
        }
    }
}
</style>